export const removeTags = (str:string) => {
    if (str === null || str === undefined) {
        str = '';
    }
    str = str.toString();
    return str.replace(/(<([^>]+)>)/ig, '');
}